import axios from "axios";
import { get, post, put, del } from "aws-amplify/api";

const API_HOST = import.meta.env.VITE_API_HOST;
const API_NAME = import.meta.env.VITE_API_NAME;

const instance = axios.create({ baseURL: API_HOST });

const makeUnpackedMethod = method => async (...params) => {
  const { data } = await method(...params);
  return data;
};

const amplifyMethodMap = {
  get: get,
  post: post,
  put: put,
  delete: del
};

import { captureEvent } from 'src/services/PostHogService';

const makeWrappedMethod = method => async (url, config = {}) => {
  const startTime = Date.now();
  const amplifyMethod = amplifyMethodMap[method];
  
  try {
    const response = await amplifyMethod({
      apiName: API_NAME,
      path: url,
      options: config
    }).response;

    const duration = Date.now() - startTime;
    captureEvent('network_request', {
      method,
      url,
      status: response.statusCode,
      duration,
    });
    
    const body = response.body;
    const text = await body.text();
    if (!text || text.trim() === '') {
      return null;
    }
    return JSON.parse(text);
  } catch (error) {
    const duration = Date.now() - startTime;
    captureEvent('network_error', {
      method,
      url,
      status: error.response ? error.response.status : 'unknown',
      duration,
      error: error.message,
    });
    throw error;
  }
};

const wrapper = {
  bare: {
    post: axios.post,
    get: axios.get,
    put: axios.put,
    delete: axios.delete
  },

  unauthenticated: {
    post: makeUnpackedMethod(instance.post),
    get: makeUnpackedMethod(instance.get),
    put: makeUnpackedMethod(instance.put),
    delete: makeUnpackedMethod(instance.delete)
  },

  post: makeWrappedMethod("post"),
  get: makeWrappedMethod("get"),
  put: makeWrappedMethod("put"),
  delete: makeWrappedMethod("delete")
};

export default wrapper;
